import api from '@/services/api';

export default {
  list(params = {}) {
    return api.get('/users', { params });
  },
  getOne(id) {
    return api.get(`/users/${id}`);
  },
  create(payload) {
    return api.post('/users', payload);
  },
  update(id, payload) {
    return api.patch(`/users/${id}`, payload);
  },
  setStatus(id, isActive) {
    return api.patch(`/users/${id}/status`, { isActive });
  },
  roles() {
    return api.get('/roles');
  },

  // Permissions: Liste aller verfügbaren Rechte
  permissionsAll() {
    return api.get('/permissions');
  },

  // Permissions des Nutzers laden
  getPermissions(id) {
    return api.get(`/users/${id}/permissions`);
  },

  // Permissions des Nutzers setzen (vollständiger Ersatz)
  // payloadOrKeys: entweder { permissions: ['approve_messages', ...] } oder direkt Array<string>
  setPermissions(id, payloadOrKeys) {
    const body = Array.isArray(payloadOrKeys)
      ? { permissions: payloadOrKeys }
      : payloadOrKeys;
    return api.put(`/users/${id}/permissions`, body);
  },

  delete(id) {
    // harter Delete: erwartet 204 No Content oder 200
    return api.delete(`/users/${id}`);
  }
};
